/**
 * Wrapper for Plyr.io
 * Node Package @link https://www.npmjs.com/package/vue-plyr
 * API @link https://github.com/sampotts/plyr
 */
import VuePlyr from "./components/vue-plyr.vue";
import EventBus from "@plugins/common/service/eventbus";
import "plyr/dist/plyr.css";

const VuePlyrPlugin = {
  install(app) {
    app.component("VuePlyr", VuePlyr);
    app.use(VuePlyr, {
      plyr: {},
    });
    this.eventBus = new EventBus();

    /**
     * Plugin API
     */
    if (!app.config.globalProperties.$plyr) {
      app.config.globalProperties.$plyr = {};
    }

    app.config.globalProperties.$plyr.pauseAll = () => {
      VuePlyrPlugin.eventBus.$emit("pause-all");
    };

    app.config.globalProperties.$plyr.destoryAll = () => {
      VuePlyrPlugin.eventBus.$emit("destroy-all");
    };
  },
};

export default VuePlyrPlugin;
